// Textos del listado de la promo por viajes (trip-promos). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'ca',
  data: {
    TRIP_PROMOS: {
      BREADCRUMB_ARIA: 'Ruta de navegació',
      BREADCRUMB_MARKETING: 'Màrqueting',
      BREADCRUMB_PROMO: 'Promo viatges',
      TITLE: 'Promo per viatges',
      DESCRIPTION:
        "Usuaris als quals s'ha activat la promo per viatges. En completar els viatges verificats de més de 10 km que es van demanar (a PVP o a cost 0, com a conductor, com a passatger o tots dos) se'ls ingressa l'import a la wallet automàticament. No té conseqüències de frau.",
      SEARCH_PLACEHOLDER: 'Cerca nom, correu o telèfon…',
      SEARCH_ARIA: 'Cerca usuari',
      STATUS_ARIA: 'Estat',
      STATUS_ALL: 'Estat: tots',
      STATUS_ACTIVE: 'En curs',
      STATUS_COMPLETED: 'Completada',
      STATUS_CANCELLED: 'Cancel·lada',
      FILTER_COMPLETED: 'Completades',
      FILTER_CANCELLED: 'Cancel·lades',
      CLEAR_FILTERS: 'Neteja els filtres',
      ACTIVATE: 'Activar promo',
      LOADING: 'Carregant promocions…',
      RETRY: 'Torna-ho a provar',
      EMPTY_FILTERED: 'Cap promoció coincideix amb la cerca.',
      EMPTY:
        "Encara no s'ha activat cap promoció. Activa-la amb «Activar promo» o des de la fitxa de l'usuari.",
      TH_USER: 'Usuari',
      TH_AMOUNT: 'Import',
      TH_ACTIVATED_BY: 'Activada per',
      TH_DATE: 'Data',
      TH_PROGRESS: 'Progrés',
      TYPE_ARIA: 'Tipus de viatge',
      TYPE_ALL: 'Tipus: tots',
      TYPE_PVP: 'A PVP',
      TYPE_WITHOUT_COST: 'A cost 0',
      TYPE_ANY: 'Qualsevol',
      ROLE_ANY: 'Conductor o passatger',
      ROLE_DRIVER: 'Només conductor',
      ROLE_RIDER: 'Només passatger',
      TH_TYPE: 'Tipus',
      TH_STATUS: 'Estat',
      OPEN: 'Obre',
      PROGRESS_TITLE: '{{done}} de {{required}} viatges',
      DEPOSITED_ON: 'Ingressada el {{date}}',
      CANCELLED_BY: 'Cancel·lada per {{name}} el {{date}}',
      VIEW_PROFILE: 'Veure fitxa',
      SHOWING: 'Mostrant',
      OF: 'de',
      PROMOS: 'promocions',
      PER_PAGE_LABEL: 'Promocions per pàgina',
      PER_PAGE_OPTION: '{{n}} per pàgina',
      PREV_PAGE: 'Pàgina anterior',
      NEXT_PAGE: 'Pàgina següent',
      PREV: 'Anterior',
      NEXT: 'Següent',
      ERROR_FORBIDDEN: 'No tens permís per veure aquest llistat.',
      ERROR_LOAD: "No s'ha pogut carregar el llistat.",
    },
  },
};
